var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 1.33335C9.1665 0.965164 8.86803 0.666687 8.49984 0.666687C8.13165 0.666687 7.83317 0.965164 7.83317 1.33335V4.00002C7.83317 4.36821 8.13165 4.66669 8.49984 4.66669C8.86803 4.66669 9.1665 4.36821 9.1665 4.00002V1.33335Z",
    fill: "#4EBC66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 12C9.1665 11.6318 8.86803 11.3334 8.49984 11.3334C8.13165 11.3334 7.83317 11.6318 7.83317 12V14.6667C7.83317 15.0349 8.13165 15.3334 8.49984 15.3334C8.86803 15.3334 9.1665 15.0349 9.1665 14.6667V12Z",
    fill: "#4EBC66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31489 2.81528C3.57524 2.55493 3.99735 2.55493 4.2577 2.81528L6.14437 4.70195C6.40472 4.9623 6.40472 5.38441 6.14437 5.64476C5.88402 5.90511 5.46191 5.90511 5.20156 5.64476L3.31489 3.75809C3.05454 3.49774 3.05454 3.07563 3.31489 2.81528Z",
    fill: "#4EBC66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7981 10.3553C11.5377 10.0949 11.1156 10.0949 10.8553 10.3553C10.5949 10.6156 10.5949 11.0377 10.8553 11.2981L12.7419 13.1848C13.0023 13.4451 13.4244 13.4451 13.6847 13.1848C13.9451 12.9244 13.9451 12.5023 13.6847 12.2419L11.7981 10.3553Z",
    fill: "#4EBC66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1665 8.00002C1.1665 7.63183 1.46498 7.33335 1.83317 7.33335H4.49984C4.86803 7.33335 5.1665 7.63183 5.1665 8.00002C5.1665 8.36821 4.86803 8.66669 4.49984 8.66669H1.83317C1.46498 8.66669 1.1665 8.36821 1.1665 8.00002Z",
    fill: "#4EBC66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 7.33335C12.1316 7.33335 11.8332 7.63183 11.8332 8.00002C11.8332 8.36821 12.1316 8.66669 12.4998 8.66669H15.1665C15.5347 8.66669 15.8332 8.36821 15.8332 8.00002C15.8332 7.63183 15.5347 7.33335 15.1665 7.33335H12.4998Z",
    fill: "#4EBC66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14437 10.3553C6.40472 10.6156 6.40472 11.0377 6.14437 11.2981L4.2577 13.1848C3.99735 13.4451 3.57524 13.4451 3.31489 13.1848C3.05454 12.9244 3.05454 12.5023 3.31489 12.2419L5.20156 10.3553C5.46191 10.0949 5.88402 10.0949 6.14437 10.3553Z",
    fill: "#4EBC66"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6847 3.75809C13.9451 3.49774 13.9451 3.07563 13.6847 2.81528C13.4244 2.55493 13.0023 2.55493 12.7419 2.81528L10.8553 4.70195C10.5949 4.9623 10.5949 5.38441 10.8553 5.64476C11.1156 5.90511 11.5377 5.90511 11.7981 5.64476L13.6847 3.75809Z",
    fill: "#4EBC66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.416afe42.svg";
export { ForwardRef as ReactComponent };